import { TimeSlot, TimeSlotGroup } from 'timeSlots/timeSlotsService'
import { DateFormats, formatOrInvalid, parseISODate } from 'utils/dates'
import { FORM_SECTION, list } from 'capacity/copy'
import { distinctWeekdays, groupRunsEveryWeekday } from 'timeSlots/domain/applicableGroups'

const SHOWN_SLOTS = 6

export const formatSlotTime = (time: string): string => time.slice(0, 5)

export const slotLabel = (slot: TimeSlot): string =>
    slot.endTime ? `${formatSlotTime(slot.startTime)}–${formatSlotTime(slot.endTime)}` : formatSlotTime(slot.startTime)

export function timesLine(slots: TimeSlot[]): string {
    const labels = slots.map(slotLabel)
    if (labels.length <= SHOWN_SLOTS) {
        return labels.join(', ')
    }
    return `${labels.slice(0, SHOWN_SLOTS).join(', ')} ${FORM_SECTION.andMore(labels.length - SHOWN_SLOTS)}`
}

export function daysLine(group: Pick<TimeSlotGroup, 'weekdays' | 'availableFrom' | 'availableTo'>): string {
    // Every day label is three letters, so the full list stays short: never fold days behind "and N more".
    const labels = distinctWeekdays(group as TimeSlotGroup).map((day) => FORM_SECTION.weekdays[day])
    const days = groupRunsEveryWeekday(group as TimeSlotGroup)
        ? FORM_SECTION.everyDay
        : labels.length === 2
        ? list(labels)
        : labels.join(', ')
    const format = (value: string) => formatOrInvalid(parseISODate(value), DateFormats.LONG_DATE)
    let dates: string | null = null
    if (group.availableFrom && group.availableTo) {
        dates = FORM_SECTION.dateRange(format(group.availableFrom), format(group.availableTo))
    } else if (group.availableFrom) {
        dates = FORM_SECTION.dateFrom(format(group.availableFrom))
    } else if (group.availableTo) {
        dates = FORM_SECTION.dateUntil(format(group.availableTo))
    }
    return dates ? `${days} · ${dates}` : days
}
